module.exports = __webpack_public_path__ + "static/home-desktop-def1e11b2c2c1766a18a88665573a2e4.png";